import axios from "axios";
const baseUrl = "/api/backend/page";

export const auditVisit = {
  submit: ({ businessKey, payload, type = "auditVisit" }) =>
    axios.post(`${baseUrl}/auditVisit?businessKey=${businessKey}`, payload),
};
